'use client';

import type EmblaCarouselComponent from '@modules/common/components/embla-carousel';
import dynamicImport from 'next/dynamic';
import type { ComponentProps } from 'react';

// Sized to roughly match a product-card row — avoids CLS while the Embla
// chunk loads, same approach as testimonials-carousel/embla-section-client.
const CarouselSkeleton = () => (
  <div className="min-h-[320px] animate-pulse rounded-lg bg-gray-100" />
);

const LazyEmblaCarousel = dynamicImport(
  () => import('@modules/common/components/embla-carousel'),
  { ssr: false, loading: CarouselSkeleton },
);

export default function EmblaCarouselClient(
  props: ComponentProps<typeof EmblaCarouselComponent>,
) {
  return <LazyEmblaCarousel {...props} />;
}
